import { Record } from "../../components/record/Record";
import { tabs } from "./treatmentTabs";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { RecordsRelated } from "../../components/recordsRelated/RecordsRelated";
import { ordersOptions } from "../orders/ordersOptions";
import { sessionsOptions } from "../sessions/sessionsOptions";
import { treatmentsOptions } from "./treatmentOptions";
import { TreatmentHeader } from "./TreatmentHeader";
import { relativesOptions } from "../relatives/relativesOptions";
import { CaseManagementNotes } from "./case-management-notes/CaseManagementNotes";
import { PsicologiaRelated } from "./psychology/PsicologiaRelated";
import { recordsRelatedCustomFilter } from "../../utils/recordsRelatedCustomFilter";
import { tasksOptions } from "../tasks/tasksOptions";
import { feedbackOptions } from "../feedbacks/feedbackOptions";
import { actions } from "./treatmentActions";
import { Treatments } from "./Treatments";
import { customerSurveyOptions } from "../customer-surveys/CustomerSurveyOptions";
import { partnersOptions } from "../partners/partnersOptions";
import { SessionsRelated } from "../sessions/components/SessionsRelated";
import { AvailabilityFinderButton } from "../../components/availability-finder/components/form/AvailabilityFinderButton";
import { AssociateRecord } from "../../components/associate-record/AssociateRecord";
import { Sandbox } from "../../sandbox/Sandbox";
import { Logbook } from "./logbook/Logbook";
import { RenderPartnerAssociateRecord } from "./PartnersAssociatedRecords/RenderPartnerAssociateRecord";
import { renderPartnerSelectedOption } from "./PartnersAssociatedRecords/renderPartnerSelectedOption";
import { associatePartnerToTreatment } from "./PartnersAssociatedRecords/associatePartnerToTreatment";
import { NeurofeedbackRelated } from "../neurofeedback-zscore-sessions/components/neurofeedback-related/NeurofeedbackRelated";
import { SelectIntakeForm } from "./intake-form/SelectIntakeForm";
import { TreatmentPrescription } from "./treatment-prescription/TreatmentPrescription";
import { TreatmentOrdersTotal } from "../orders/TreatmentOrdersTotal";

export const fieldsQuery =
    [
        "*.*",
        "client.user_id.*",
        "client_owner.user_id.*",
        "theurapist.user_id.*",
        "client_manager.technicians_id.*",
        "client_manager.technicians_id.user_id.*",
        "theurapists_involved_in_treamtent.technicians_id.user_id.*",
        "theurapists_involved_in_treamtent.technicians_id.*",
        "relative_resposible_for_treatment.relatives_id.*",
        "partners.professional_partners_id.*",
        "client.clinic_id.name",
        "client.clinic_id.id",
        "client.clinic_id.receptionist.phone",
        "diagnose_secondary_multi.disorders_id.*",
        "sessions.service.id",
        "sessions.service.name",
    ].join(",") + "&deep[sessions][_limit]=-1";

export const heightOfHeaders = 398;

export const treatmentRoutes = [
    {
        path: "/treatments",
        element: <Treatments entity="treatments" fieldsQuery={fieldsQuery} options={treatmentsOptions} />,
    },
    {
        path: "/treatments/:id",
        element: (
            <Record
                entity="treatments"
                fieldsQuery={fieldsQuery}
                type="detail"
                options={treatmentsOptions.groupsOptions}
                header={<TreatmentHeader actions={actions} />}
                body={<DetailTabs tabs={tabs} />}
            />
        ),

        children: [
            {
                element: <Groups groupsOptions={treatmentsOptions.groupsOptions} />,
                path: "/treatments/:id/detail",
            },
            {
                element: <SelectIntakeForm />,
                path: "/treatments/:id/intake_form",
            },
            {
                element: (
                    <RecordsRelated
                        entity="sessions"
                        fieldsToQuery="*.*,client.user_id.*,technician.user_id.*,treatment.client.*,treatment.client.clinic_id.id,treatment.client.clinic_id.name,treatment.client.user_id.*"
                        fieldToFilter="treatment"
                        recordsOptions={sessionsOptions}
                        heightOfHeaders={heightOfHeaders}
                        customComponentHeader={<AvailabilityFinderButton />}
                        customComponentContent={
                            <SessionsRelated heightOfHeaders={heightOfHeaders} sessionsOptions={sessionsOptions} />
                        }
                    />
                ),
                path: "/treatments/:id/sessions",
            },
            {
                element: <TreatmentPrescription />,
                path: "/treatments/:id/treatment_prescription",
            },
            {
                element: <NeurofeedbackRelated heightOfHeaders={heightOfHeaders} />,
                path: "/treatments/:id/neurofeedback_data",
            },
            {
                element: (
                    <RecordsRelated
                        entity={"orders"}
                        fieldsToQuery="*.*,client_id.user_id.*,treatment.client.*, treatment.client.user_id.*"
                        fieldToFilter="treatment"
                        recordsOptions={ordersOptions}
                        heightOfHeaders={heightOfHeaders}
                        customComponentHeader={<TreatmentOrdersTotal />}
                    />
                ),
                path: "/treatments/:id/orders",
            },
            {
                element: <PsicologiaRelated />,
                path: "/treatments/:id/psychology",
            },
            {
                element: <CaseManagementNotes />,
                path: "/treatments/:id/notes",
            },
            {
                element: (
                    <RecordsRelated
                        entity="relatives"
                        fieldsToQuery="*.*,client.user_id.*"
                        customFilter={(params) => {
                            return {
                                client_id: {
                                    treatments: {
                                        id: {
                                            _eq: params.parentId,
                                        },
                                    },
                                },
                            };
                        }}
                        recordsOptions={relativesOptions}
                        heightOfHeaders={heightOfHeaders}
                    />
                ),
                path: "/treatments/:id/relatives",
            },
            {
                element: (
                    <RecordsRelated
                        entity={"feedbacks"}
                        fieldsToQuery="*.*, treatment.client.*, treatment.client.user_id.*"
                        fieldToFilter="treatment"
                        recordsOptions={feedbackOptions}
                        heightOfHeaders={heightOfHeaders}
                    />
                ),
                path: "/treatments/:id/feedbacks",
            },
            {
                element: (
                    <RecordsRelated
                        entity="tasks"
                        fieldsToQuery="*.*,assigned_users.directus_users_id.*, related_with.item:leads.*, related_with.item:clients.*, related_with.item:treatments.client.client_id,status, comments.user_created.*"
                        customFilter={recordsRelatedCustomFilter}
                        recordsOptions={tasksOptions}
                        heightOfHeaders={heightOfHeaders}
                    />
                ),
                path: "/treatments/:id/tasks",
            },
            {
                element: (
                    <RecordsRelated
                        entity="customer_surveys"
                        fieldsToQuery="*.*,treatment.client.*.*"
                        fieldToFilter="treatment"
                        recordsOptions={customerSurveyOptions}
                        heightOfHeaders={heightOfHeaders}
                    />
                ),
                path: "/treatments/:id/customer_surveys",
            },
            {
                element: (
                    <RecordsRelated
                        entity="professional_partners"
                        fieldsToQuery="*.*"
                        customFilter={(params) => {
                            return {
                                treatments: {
                                    treatments_id: {
                                        id: {
                                            _eq: params.parentId,
                                        },
                                    },
                                },
                            };
                        }}
                        recordsOptions={partnersOptions}
                        heightOfHeaders={heightOfHeaders}
                        customComponentHeader={
                            <AssociateRecord
                                associateItemToRecord={associatePartnerToTreatment}
                                asyncAutoCompleteProps={{
                                    fieldName: "professional_partner",
                                    placeholder: "Pesquise o parceiro",
                                    recordsOptions: {
                                        entity: "professional_partners",
                                        fieldsToQuery: "*.*",
                                        labelKey: renderPartnerSelectedOption,
                                        customFilter: (value: string) => ({
                                            _and: [
                                                {
                                                    name: { _icontains: value },
                                                },
                                            ],
                                        }),
                                        renderOption: (props: any, option: any) => (
                                            <RenderPartnerAssociateRecord key={option.id} option={option} props={props} />
                                        ),
                                    },
                                }}
                            />
                        }
                    />
                ),
                path: "/treatments/:id/professional_partners",
            },
            {
                element: <Logbook />,
                path: "/treatments/:id/logbook",
            },
            {
                element: <Sandbox />,
                path: "/treatments/:id/timeline",
            },
        ],
    },
    {
        path: "/treatments/:id/update",
        element: (
            <Record
                entity="treatments"
                fieldsQuery={fieldsQuery}
                type="update"
                body={<EntityForm groupsOptions={treatmentsOptions.groupsOptions} />}
            />
        ),
    },
    {
        path: "/treatments/create",
        element: (
            <Record
                entity="treatments"
                fieldsQuery={fieldsQuery}
                type="create"
                body={<EntityForm groupsOptions={treatmentsOptions.groupsOptions} />}
            />
        ),
    },
];
